<template>
  <g>
    <path
      d="M19 19.0002H3C2.45 19.0002 2 19.4502 2 20.0002C2 20.5502 2.45 21.0002 3 21.0002H19C19.55 21.0002 20 20.5502 20 20.0002C20 19.4502 19.55 19.0002 19 19.0002Z"
    />
    <path
      d="M20 3.00024H9V5.40024L10.81 6.85024C10.93 6.94024 11 7.09024 11 7.24024V11.5002C11 11.7802 10.78 12.0002 10.5 12.0002H6.5C6.22 12.0002 6 11.7802 6 11.5002V7.24024C6 7.09024 6.07 6.94024 6.19 6.85024L8 5.40024V3.00024H6C4.9 3.00024 4 3.90024 4 5.00024V13.0002C4 15.2102 5.79 17.0002 8 17.0002H14C16.21 17.0002 18 15.2102 18 13.0002V10.0002H20C21.1 10.0002 22 9.10024 22 8.00024V5.00024C22 3.90024 21.1 3.00024 20 3.00024ZM20 8.00024H18V5.00024H20V8.00024Z"
    />
  </g>
</template>
